import {environment} from '../../environments/environment';

declare global {
  interface Window {
    Cookiebot?: any;
    OneSignalDeferred?: any[];
  }
}


/**
 * Load the OneSignal SDK and init it (only if marketing cookies accepted).
 */
export function loadOneSignal(): void {
  // Only load if Cookiebot says marketing cookies are accepted
  if (!window.Cookiebot?.consent?.marketing) {
    return;
  }

  // Avoid injecting the SDK twice
  if (document.querySelector('script[src*="OneSignalSDK.page.js"]')) {
    return;
  }

  const s = document.createElement('script');
  s.src = 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js';
  s.async = true;
  s.onload = () => {
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push((OneSignal: any) => {
      const hostname = window.location.hostname || '';
      const isDev = hostname.includes('dev') || hostname.includes('localhost');

      const initConfig: any = { appId: environment.oneSignalAppId };

      if (isDev) {
        // dev-only extras
        initConfig.safari_web_id = 'web.onesignal.auto.1947bcbb-3df5-45a5-b464-0be0e15f4a2c';
        initConfig.notifyButton = { enable: true };
      }

      try {
        OneSignal.init(initConfig);
      } catch (err) {
        console.error('[onesignal-loader] OneSignal.init failed', err);
      }
    });
  };

  document.head.appendChild(s);
}

// Auto-register: listen for Cookiebot acceptance
if (typeof window !== 'undefined') {
  window.addEventListener('CookiebotOnAccept', () => loadOneSignal());

  // If Cookiebot already exists and marketing was already granted, load immediately
  if (window.Cookiebot?.consent?.marketing) {
    // small timeout to ensure any Cookiebot finalization is done
    setTimeout(() => loadOneSignal(), 0);
  }
}
